export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/c5d6534f4f2cb925009575e748220704.svg";